import api from './api';

// Talks to /api/capex — the five-year capital programme.
//
// { financialYear, statuses, rows, periods, years, picks }
//
//   rows     one per project, from vw_bud_capex_plan: opening balance, the
//            year-1 total, years 2-5 and the whole programme
//   periods  year 1 BY MONTH — the only part any statement reads
//   years    years 2-5, ANNUAL, keyed by year_offset (2 = the year after the
//            one this version budgets). Relative on purpose, so rolling a
//            version forward does not mean rewriting every out-year.
//
// YEARS 2-5 ARE PLANNING ONLY. The P&L, cash flow and balance sheet are
// budget-year statements and read bud_capex_periods alone. Nothing but the
// Capital page should ever read `years`.
export const capexService = {
  get: async () => {
    const res = await api.get('/capex');
    return res.data;
  },

  // The WHOLE project in one call — header plus phasing plus out-years,
  // committed atomically. A header saved without its phasing is a capital plan
  // that has silently lost its money.
  save: async (project) => {
    const res = await api.put('/capex', project);
    return res.data;
  },

  remove: async (capexRef) => {
    const res = await api.delete(`/capex/${encodeURIComponent(capexRef)}`);
    return res.data;
  },
};

export default capexService;
